import _extends from '@babel/runtime/helpers/extends';
import { headingStyles, bodyStyles } from './styles.js';
import { jsx } from '@emotion/react';
import filterDataAttributes from '../../utils/filter-data-attributes.js';

var Heading = function Heading(props) {
  var as = props.as,
      children = props.children,
      title = props.title,
      type = props.type;
  var HeadingElement = type || as;
  return jsx(HeadingElement, _extends({
    css: function css(theme) {
      return headingStyles(props, theme);
    },
    title: title
  }, filterDataAttributes(props)), children);
};
Heading.displayName = 'TextHeading';
var Body = function Body(props) {
  var as = props.as,
      children = props.children,
      isInline = props.isInline,
      title = props.title;
  if (as) {
    var BodyElement = as;
    return jsx(BodyElement, _extends({
      css: function css(theme) {
        return bodyStyles(props, theme);
      },
      title: title
    }, filterDataAttributes(props)), children);
  }
  return isInline ? jsx("span", _extends({
    css: function css(theme) {
      return bodyStyles(props, theme);
    },
    title: title
  }, filterDataAttributes(props)), children) : jsx("p", _extends({
    css: function css(theme) {
      return bodyStyles(props, theme);
    },
    title: title
  }, filterDataAttributes(props)), children);
};
Body.displayName = 'TextBody';
var Text = {
  Heading: Heading,
  Body: Body
};

export default Text;
export { Body, Heading };
//# sourceMappingURL=text.js.map
